import { useQuery } from '@tanstack/react-query'

const fetchDatasetSummary = async (datasetId, isSegment) => {
  const endpoint = isSegment
    ? `${process.env.REACT_APP_API_URL}/api/datasets/region-datasets/${datasetId}/analyze?action=summary`
    : `${process.env.REACT_APP_API_URL}/api/datasets/${datasetId}/analyze?action=summary`

  const response = await fetch(endpoint, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })

  if (response.status === 200) {
    const result = await response.json()

    return result.data
  } else {
    throw new Error('Failed to fetch dataset summary')
  }
}

const useDatasetSummary = (datasetId, updatedAt, isSegment = false) => {
  return useQuery({
    queryKey: ['datasetSummary', datasetId, updatedAt], // Add updatedAt to cache key
    queryFn: () => fetchDatasetSummary(datasetId, isSegment),
    staleTime: 5 * 60 * 1000,
    gcTime: 5 * 60 * 1000, // cacheTime is now called gcTime in v5
    enabled: !!datasetId,
    retry: false,
  })
}

export default useDatasetSummary
